import { Container } from "react-bootstrap";
import Logo from "../assets/logo.png";
import { TypeAnimation } from "react-type-animation";
import "../styles/home.css";
import AboutUs from "./AboutUs";
import ContactUs from "./ContactUs";

export default function Home() {
  return (
    <>
      <section className="hero-logistics">
        <Container className="text-center hero-content">
          <img
            src={Logo}
            alt="RR Shipping & Logistics"
            className="hero-logo mb-4"
          />

          <h1 className="hero-title">RR SHIPPING & LOGISTICS</h1>

          <p className="hero-tagline mt-3">Your Global Movement Partner</p>

          <div className="hero-services mt-3">
            <TypeAnimation
              sequence={[
                "We Offer: Custom Clearance",
                1500,
                "We Offer: Transportation",
                1500,
                "We Offer: Freight Forwarding",
                1500,
              ]}
              wrapper="div"
              speed={50}
              style={{ fontSize: "1.2em", display: "inline-block" }}
              repeat={Infinity}
            />
          </div>
        </Container>
      </section>
      <section id="about-us">
        <AboutUs></AboutUs>
      </section>
      <section id="contact-us">
        <ContactUs></ContactUs>
      </section>
    </>
  );
}
